export default {
	getAccount(state) {
		
	}
}